module.exports = __webpack_public_path__ + "img/Rectangle_41.abe0879a.svg";